import raiseImg from "../assests/image/raise.png";
import closeImg from "../assests/image/close.png";
import openImg from "../assests/image/open.png";
import vectorImg from "../assests/image/Vector.svg";

export const getTicketData = (enquiryCount) => [
  {
    id: 1,
    title: "Total Enquiries",
    value: enquiryCount.toLocaleString(),
    percentage: "0%",
    month: "this month",
    imgSrc: raiseImg,
    vector: vectorImg, 
    isPositive: true,
  },
  {
    id: 2,
    title: "Total Close Tickets",
    value: "0",
    percentage: "0%",
    month: "this month",
    imgSrc: closeImg, 
    vector: vectorImg, 
    isPositive: false,
  },
  {
    id: 3,
    title: "Total Open Tickets",
    value: "0",
    imgSrc: openImg,
    vector: null, 
    isPositive: null,
  },
];
